if (!customElements.get('shopping-goal-progress')) {
  customElements.define(
    'shopping-goal-progress',
    class ShoppingGoalProgress extends HTMLElement {
      constructor() {
        super();
        this.curCountry = this.dataset.country
        this.cartTotal = Number(this.dataset.cartTotal ?? 0)
        this.settings = []
        this.goalBlocks = this.querySelectorAll("[class*='-goal']")
        this.progressBar = this.querySelector('.progress-bar')
        this.progressTip = this.querySelector('.goal-progress-tip')
        this.settingHtml = window.document.querySelector('#shopping-goal-progress-settings').innerHTML
      }

      connectedCallback() {
        this.init()

        document.addEventListener('cart:updated', (event) => {
          const items = event.detail.cart.items ?? []
          this.renderProgress(event.detail.cart.items_subtotal_price);
        });
      }
      
      initSettings() {
        try {
          const settings = JSON.parse(this.settingHtml ?? "{}")
          this.finishGoalTip = settings.finish_goal_tip
          const newSettings = []
          const firstGoal = this.transferGoal(settings.first_goal)
          if (firstGoal != null) {
            newSettings.push({
              title: settings.first_goal_title,
              tip: settings.first_goal_tip,
              goal: firstGoal,
              index: 0
            })
          }
          const secondGoal = this.transferGoal(settings.second_goal)
          if (secondGoal != null) {
            newSettings.push({
              title: settings.second_goal_title,
              tip: settings.second_goal_tip,
              goal: secondGoal,
              index: 1
            })
          }
          const thirdGoal = this.transferGoal(settings.third_goal)
          if (thirdGoal != null) {
            newSettings.push({
              title: settings.third_goal_title,
              tip: settings.third_goal_tip,
              goal: thirdGoal,
              index: 2
            })
          }
          this.settings = newSettings
          
        } catch (e) {
          console.error(e)
        }
      }

      transferGoal(goalStr) {
        if (!goalStr || !this.curCountry) return
        const goalByCountry = goalStr.split('\n').map((goal) => {
          return goal?.split('::') ?? []
        })
        let goalForCurCountry = goalByCountry.find((arr) => arr[0] === this.curCountry)?.[1]
        if (goalForCurCountry == null) {
          goalForCurCountry = goalByCountry.find((arr) => arr[0] === 'default')?.[1]
        }
        return goalForCurCountry
      }

      formatMoneyToCurCountry(money) {
        return Number(money) * Number(window.Shopify.currency.rate || 1);
      }

      formatGoalMoney(shopAmount) {
        const cents = Math.round(this.formatMoneyToCurCountry(shopAmount) * 100);
        const format = window.FoxTheme?.settings?.moneyFormat;
        if (window.FoxTheme?.Currency?.formatMoney && format) {
          return window.FoxTheme.Currency.formatMoney(cents, format);
        }
        return (cents / 100).toFixed(2);
      }

      /*
        标题在 section block 设置里，不能写 {{ }}，否则主题编辑器会当成无效动态数据源。
        用 {6} 表示店铺货币金额。{{ 6 }} 仅在直接写入 JSON 时仍可识别。
      */
      formatTitle(template) {
        return String(template || '').replace(/\{\{\s*(\d+(?:\.\d+)?)\s*\}\}|\{\s*(\d+(?:\.\d+)?)\s*\}/g, (_, doubled, single) => {
          return this.formatGoalMoney(doubled || single);
        });
      }

      renderProgress(cartTotal) {
        if (cartTotal == null || !this.settings.length) return
        if (!cartTotal) {
          this.progressBar.style.setProperty('--percent', '0%')
          this.settings.forEach((item) => {
            const { index } = item
            const goalBlock = this.goalBlocks[index]
            goalBlock?.classList.remove('active')
          })
          this.classList.add('hidden')
          return
        }
        const startLeftOffset = 100 / this.settings.length
        let isShotOneGoal = false
        this.settings.forEach((item, i) => {
          const { goal, index, tip } = item
          const goalBlock = this.goalBlocks[index]
          const goalByCurrency = this.formatMoneyToCurCountry(goal) * 100;
          if (cartTotal < goalByCurrency) {
            if (isShotOneGoal) {
              goalBlock.classList.remove('active')
              return
            }
            const preItem = this.settings[i - 1] ?? { goal: 0 }
            const preGoal = this.formatMoneyToCurCountry(preItem.goal) *100;
            const diffGoal = goalByCurrency - preGoal, diffMoney = cartTotal - preGoal
            const precent = (diffMoney / diffGoal) * startLeftOffset + startLeftOffset * i
            this.progressBar.style.setProperty('--percent', precent + '%')

            const diffToGoal = ((goalByCurrency - cartTotal)/100).toFixed(2)
            this.progressTip.textContent = tip.replace('{money}', FoxTheme.Currency.formatMoney(
              diffToGoal,
              this.money_format
            ))
            goalBlock.classList.remove('active')
            isShotOneGoal = true
          } else {
            goalBlock.classList.add('active')
            if (i === this.settings.length - 1) {
              this.progressBar.style.setProperty('--percent', '100%')
              this.progressTip.textContent = this.finishGoalTip
            }
          }
        })
        if (!isShotOneGoal) {
          this.progressBar.style.setProperty('--percent', '100%')
          this.progressTip.textContent = this.finishGoalTip
        }
        this.classList.remove('hidden')
      }

      initRender() {
        if (!this.settings.length) return
        const startLeftOffset = 100 / this.settings.length
        this.settings.forEach((item, i) => {
          const {index, title, goal } = item
          const goalBlock = this.goalBlocks[index]
          if (!goalBlock) return
          const goalAmountBlock = goalBlock.querySelector('.goal-amount')
          const goalTitleBlock = goalBlock.querySelector('.goal-title')
          if (goalAmountBlock) goalAmountBlock.textContent = this.formatGoalMoney(goal)
          goalTitleBlock.textContent = this.formatTitle(title)
          goalBlock.classList.remove('hidden')
          goalBlock.style.left = startLeftOffset * (i + 1) + '%'
        })
        if (!this.cartTotal) return
        this.classList.remove('hidden')
        this.renderProgress(this.cartTotal)
      }

      init() {
        this.initSettings()
        this.initRender()
      }
      
    }
  );
}